import { createContext } from 'react'
import type { CurrentUser } from '../api/auth'

export interface AuthState {
  user: CurrentUser | null
  loading: boolean
  authenticated: boolean
  openMode: boolean
  ssoEnabled: boolean
  signOut: () => Promise<void>
  refresh: () => Promise<void>
}

export const AuthContext = createContext<AuthState>({
  user: null,
  loading: true,
  authenticated: false,
  openMode: false,
  ssoEnabled: false,
  signOut: async () => {},
  refresh: async () => {},
})
